module.exports = __webpack_public_path__ + "img/lens-150-minus-08.d0ab8871.png";